import { t } from 'i18next';

export const scheduleTabs = {
  scheduleBoard: {
    key: 'schedule-board',
    label: t('scheduling.scheduleBoard.scheduleBoard'),
  },
  workshopView: {
    key: 'workshop-view',
    label: t('workshop.workshopView'),
  },
  resourceView: {
    key: 'resource-view',
    label: t('scheduling.resourceView.title'),
  },
};
